<div class="filter-sort-form" *ngIf="model && model.filterBy">
  <div class="d-flex flex-wrap justify-content-between">
    <rr-date-range-field
      [(ngModel)]="model.filterBy.value"
      [settings]="dateRangeFieldModel"
      (clearInput)="onClearDateRangeField($event)"
      (ngModelChange)="onDateRangeFieldChange($event)"
    >
    </rr-date-range-field>
  </div>
</div>
